import { BASE_URL } from "#next-seo.config";
import { generateNextSeo } from "next-seo/pages";
import Head from "next/head";
import Container from "~/components/Container";
import { WorkList } from "~/components/WorkList";

export const relativeUrl = `/work`;
export const url = `${BASE_URL}${relativeUrl}`;
export const title = "Samuel Batista's Work";

export async function getStaticProps() {
  const [portableSecret] = await Promise.all([import("./work/open-source/portable-secret")]);

  return {
    props: {
      portableSecret: {
        title: portableSecret.title,
        url: portableSecret.url,
        description: portableSecret.description
      }
    }
  };
}

export default function WorkOpenSource({ portableSecret }) {
  return (
    <Container>
      <Head>
        {generateNextSeo({
          title,
          canonical: url,
          openGraph: {
            url,
            title
          }
        })}
      </Head>
      <div className="flex flex-col justify-center items-start max-w-2xl mx-auto mb-16">
        <h1 className="font-bold text-3xl md:text-5xl tracking-tight mb-4 text-black dark:text-white">Work</h1>
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-1 my-2 w-full mt-4">
          <WorkList portableSecret={portableSecret} />
        </div>
      </div>
    </Container>
  );
}
